var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var defaultListenerOption = {
    stopPropagation: false,
};
export function create(listener, listenerOption) {
    return function (event) {
        var option = __assign(__assign({}, defaultListenerOption), listenerOption);
        if (option.stopPropagation) {
            event.stopImmediatePropagation();
        }
        listener(event.detail);
    };
}
export function on(type, createdEventListener) {
    window.addEventListener(type, createdEventListener, false);
}
export function once(type, createdEventListener) {
    window.addEventListener(type, createdEventListener, { once: true });
}
export function off(type, createdEventListener) {
    window.removeEventListener(type, createdEventListener, false);
}
export function emit(type, detail) {
    window.dispatchEvent(new CustomEvent(type, { detail: detail }));
}
//# sourceMappingURL=events.js.map